import { createFileRoute, redirect } from '@tanstack/react-router';

import { parseHttpError } from '@repo/utils/parse-http-error';

import { queryCurrentUser, queryProjectById, queryProjects } from '~/services/authorization/authorization.ts';
import { NotFoundError } from '~/services/http.ts';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context: { queryClient } }) => {
    const user = await queryClient.ensureQueryData(queryCurrentUser());
    const projects = await queryClient.ensureQueryData(queryProjects(user.organizationId));

    if (projects.length === 1 && projects[0]) {
      try {
        await queryClient.ensureQueryData(queryProjectById(projects[0].id));
        throw redirect({ to: '/project/$project', params: { project: projects[0].id } });
      }
      catch (error) {
        const status = parseHttpError(error).status;
        const hasNoProjectAccess = error instanceof NotFoundError || status === 401 || status === 403 || status === 404;

        if (!hasNoProjectAccess) {
          throw error;
        }
      }
    }

    throw redirect({ to: '/organization/$org', params: { org: user.organizationId }, replace: true });
  },
  loader: async ({ context: { queryClient } }) => {
    const user = await queryClient.ensureQueryData(queryCurrentUser());

    await queryClient.ensureQueryData(queryProjects(user.organizationId));
  },
});
